<template>
    <ul
        :class="{'mb-5': isDaysBack}"
    >
        <li
            v-for="(percent, countMonth) in tariffPercents"
            class="relative"
            :class="{
                active: isActiveTermTab('month_' + countMonth),
                'has-percents': (percent > 0),
                'black': showBanner
            }"
            :key="'month_' + countMonth"
            :data-percent="percent"
            @click="onClickTab('month_' + countMonth, percent, countMonth)"
        >
            {{ $t('lang.main.month_' + countMonth) }}
            <div v-if="isDaysBack" class="tabs__dayback_container">
                <div class="tabs__dayback">
                    <img src="/i/pages/tariff/gift.svg" alt="" />
                    <span>{{ getDayBackLabel(countMonth) }}</span>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>

export default {
    name: "TariffPageTabs",
    props: {
        tariffPercents: Object,
        isActiveTermTab: Function,
        onClickTab: Function,
    },
    data() {
        return {
            // месяцев: дней
            daybackRelations: {
                1: 7,
                3: 10,
                6: 15,
                12: 30,
            }
        }
    },
    computed: {
        isDaysBack() {
            // #dayback
            let date = new Date()
            return (new Date('2025-12-01T00:00:00+03:00')) < date && date < (new Date('2026-01-01T00:00:00+03:00'));
        },
        showBanner() {
            // #promotion
            let date = new Date()
            return (new Date('2026-05-28T00:00:00+03:00')) < date && date < (new Date('2026-06-02T00:00:00+03:00'));
        },
    },
    methods: {
        getDayBackLabel(countMonth) {
            return this.$t('lang.pages.tariff.tabs.dayback_label', [this.daybackRelations[countMonth]]);
        }
    }
}
</script>

<style scoped>
.tabs__dayback_container {
    position: absolute;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    top: 90%;
}
.tabs__dayback {
    background-color: #9CD651;
    padding: 4px 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 4px;
}
.tabs__dayback_container span {
    font-weight: 700;
    font-size: 13px;
    color: #1D1D1F;
}
ul {
    list-style: none;
    border: 1px solid #A4B1BE;
    border-radius: 8px;
    padding: 4px;
    display: flex;
    margin: 0 auto 24px;
    width: max-content;
    gap: 4px;
}
li {
    position: relative;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 16px;
    line-height: 24px;
    cursor: pointer;
    color: #A4B1BE;
}
li.active {
    background: #EBF1F7;
    cursor: default;
    color: #232D35;
}
li.has-percents:after {
    content: '-' attr(data-percent) '%';
    position: absolute;
    bottom: 36px;
    background-color: #FFE500;
    color: #232D35;
    border-radius: 5px;
    font-size: 13px;
    padding: 4px 8px;
    letter-spacing: -0.085em;
    line-height: 150%;
    font-weight: 700;
    left: calc(50% - 20px);
}

li.has-percents.black:after {
    left: calc(50% - 45px);
}

li.has-percents.black:before {
    content: '-20%';
    position: absolute;
    bottom: 36px;
    background-color: #6eb116;
    color: white;
    border-radius: 5px;
    font-size: 13px;
    padding: 4px 8px;
    letter-spacing: -0.085em;
    line-height: 150%;
    font-weight: 700;
    left: calc(50% + 5px);
}


li.black:before {
    content: '-20%';
    position: absolute;
    bottom: 36px;
    background-color: #6eb116;
    color: white;
    border-radius: 5px;
    font-size: 13px;
    padding: 4px 8px;
    letter-spacing: -0.085em;
    line-height: 150%;
    font-weight: 700;
    left: calc(50% - 20px);
}

@media (max-width: 550px) {
    ul {
        width: auto;
        flex-wrap: wrap;
        border: unset;
    }
    li {
        margin: 4px;
        flex: 1 1 auto;
        text-align: center;
    }
    li:not(.active) {
        border: 1px solid #A4B1BE;
    }
    li.has-percents:after {
        position: static;
    }
    li.has-percents.black:before {
        position: static;
    }
    .tabs__dayback_container {
        position: static;
    }
}
</style>
